import { useEffect, useState, type Dispatch, type SetStateAction } from "react";

// ui
import {
  Box,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";

// Table
import { ConstTable } from "../component/Table";

// Bar
import TableTopBar from "../component/TableTopBar";
import SerchSideBar from "../component/SerchSideBar";
import AiChatSideBar from "../component/AiChatSideBar";

// Modal
import { DataDetailModal } from "../component/detail/DataDetailModal";
import { DataEditModal } from "../component/DataEditModal";
import { DataAddModal } from "../component/DataAddModal";
import { DataAddModalResult } from "../component/DataAddModalResult";
import { PostCSVModal } from "../component/PostCSVModal";
import { ProductEditModal } from "../component/ProductEditModal";
import { DataDeleteModal } from "../component/tableFunction/DataDeleteModal";
import { FormOptionsEditModal } from "../component/tableFunction/FormOptionsEditModal";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getEntryForms,
  getEntryForm,
  postEntryForm,
  putEntryForm,
  deleteEntryForm,
  postEntryFormOptions,
  deleteEntryFormOptions,
  getEntryFormDeleteOptionNames,
} from "../api/entryForm";
import {
  getProductOptions,
  putProductOptions,
  getProductOption,
} from "../api/productOption";
import { getProductOptionSelects } from "../api/productOptionSelect";
import { getProductOptionDependPlans } from "../api/productOptionDependPlan";
import { getProductOptionDependContents } from "../api/productOptionDependContent";
import { getProductOptionDependSelects } from "../api/productOptionDependSelect";
import { getPresignedPostCSV, postPresignedPost } from "../api/presignedURL";
import {
  getSerchHighRankCompanys,
  getSerchProducts,
  getSerchSaleCompanys,
} from "../api/serch";
import {
  getEntryFormChatApps,
  getEntryFormChatApp,
  postEntryFormChatApp,
  putEntryFormChatApp,
  deleteEntryFormChatApp,
} from "../api/entryFormChatApp";
import {
  getEntryFormChatAppDependSelects,
  postEntryFormChatAppDependSelect,
  deleteEntryFormChatAppDependSelect,
  getEntryFormOptionsForChatAppDepend,
} from "../api/entryFormChatAppDependSelect";

// InterFace
import { entryFormTableColumn } from "../config/entryForm";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

const postCSVColumnProductOption = [
  "上位店名",
  "商材名",
  "エントリーパートナー",
  "質問名",
  "チャットアプリ連携",
  "必須フラグ",
  "質問区分",
  "デフォルト値",
  "入力値の編集",
  "説明",
  "フラグ設定",
  "依存プラン1",
  "依存プラン2",
  "、",
  "依存プラン5",
  "依存コンテンツ1",
  "依存コンテンツ2",
  "、",
  "依存コンテンツ5",
  "依存質問名",
  "依存選択肢1",
  "依存選択肢2",
  "、",
  "依存選択肢5",
  "選択肢1",
  "選択肢2",
  "、",
  "選択肢20",
];

const postCSVColumnProductOptionResult = [
  "上位店名",
  "商材名",
  "エントリーパートナー",
  "質問名",
  "必須フラグ",
  "質問区分",
  "デフォルト値",
  "入力値の編集",
  "説明",
  "フラグ設定",
];

function EntryForm() {
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "エントリーフォーム登録",
    },
  ];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "質問登録CSV取込",
    },
  ];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {
    if (addDataName === "エントリーフォーム登録") {
      setEntryFormAddModal(true);
    }
  }, [addDataName]);

  useEffect(() => {
    if (addCSVDataName === "質問登録CSV取込") {
      setPostProductOptionCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
  }, [addCSVDataName]);

  useEffect(() => {
    if (editDatasName === "質問追加・削除") {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "open",
      });
    }
  }, [editDatasName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubTableName.name === "質問一覧") {
      getSubtableDataProductOption();
    }
    if (getSubTableName.name === "チャットアプリ連携一覧") {
      getSubtableDataEntryFormChatApp();
    }
  }, [getSubTableName.name, getSubTableName.key]);

  // サブテーブルデータの詳細取得
  const [getSubTableDetail, setGetSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({
    name: "",
    key: {},
    dataDetail: null,
  });
  useEffect(() => {
    if (getSubTableDetail.name === "チャットアプリ連携詳細") {
      getDataDetailEntryFormChatApp();
    }
  }, [getSubTableDetail.name, getSubTableDetail.key]);

  // サブテーブルの一覧をメインテーブルの詳細表示（エントリーフォーム用）
  const [getSubMainTableDetail, setGetSubMainTableName] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (getSubMainTableDetail.name === "質問一覧 詳細 / 編集") {
      getDataDetailProductOptionsMain(false);
    }
  }, [getSubMainTableDetail.name, getSubMainTableDetail.key]);

  // サブテーブルデータの登録
  const [getSubTableAdd, setGetSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {
    if (
      getSubTableAdd.name === "チャットアプリ連携追加" &&
      getSubTableAdd.row
    ) {
      setAddEntryFormChatApp({
        ...addEntryFormChatApp,
        entry_form_id: String(getSubTableAdd.row.id),
      });
      setOnEntryFormChatAppAddModal(true);
    }
  }, [getSubTableAdd.name, getSubTableAdd.row]);

  // サブサブテーブルデータの一覧取得
  const [getSubSubTableName, setGetSubSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  const [getSubSubTableDetail, setGetSubSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({ name: "", key: {}, dataDetail: null });
  useEffect(() => {
    if (getSubSubTableName.name === "選択肢一覧") {
      getSubSubtableDataProductOptionSelect();
    }
    if (getSubSubTableName.name === "依存プラン一覧") {
      getSubSubtableDataProductOptionDependPlan();
    }
    if (getSubSubTableName.name === "依存コンテンツ一覧") {
      getSubSubtableDataProductOptionDependContent();
    }
    if (getSubSubTableName.name === "依存質問-選択肢一覧") {
      getSubSubtableDataProductOptionDependSelect();
    }
    if (getSubSubTableName.name === "チャット連携-依存質問-選択肢一覧") {
      getSubSubtableDataEntryFormChatAppDependSelect();
    }
  }, [getSubSubTableName.name, getSubSubTableName.key]);

  // テーブル関数
  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
    subTableColumnName?: string;
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (
      tableOriginalFunc.name === "削除" &&
      tableOriginalFunc.subTableColumnName ===
        "チャット連携-依存質問-選択肢一覧"
    ) {
      setDeleteChatAppDependSelectInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    } else if (
      tableOriginalFunc.name === "削除" &&
      tableOriginalFunc.subTableColumnName === "チャットアプリ連携一覧"
    ) {
      setDeleteChatAppInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    } else if (tableOriginalFunc.name === "削除") {
      setDeleteDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
  }, [
    tableOriginalFunc.name,
    tableOriginalFunc.key,
    tableOriginalFunc.subTableColumnName,
  ]);

  // 検索欄、テーブル等の高さ
  const [tableHeight, setTableHeight] = useState("calc(100vh - 110px)");
  useEffect(() => {
    const tableHeight = isSmartPhone
      ? "calc(100vh - 190px)"
      : "calc(100vh - 110px)";
    setTableHeight(tableHeight);
  }, [isSmartPhone]);
  const [serchOpen, setSerchOpen] = useState(false);
  const [aiChatOpen, setAiChatOpen] = useState(false);
  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open) setAiChatOpen(false);
  };
  const handleSetAiChatOpen = (open: boolean) => {
    setAiChatOpen(open);
    if (open) setSerchOpen(false);
  };

  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const serchColumn = entryFormTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.serch === true) {
        if (difine.serchType === "date") {
          return {
            ...column,
            [difine.key + "_start"]: "",
            [difine.key + "_end"]: "",
          };
        } else if (difine.serchType === "payment_year_month") {
          return {
            ...column,
            payment_year: thisYear.toString(),
            payment_month: thisMonth.toString(),
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {},
  );
  const [serchString, setSerchString] = useState(serchColumn);
  const [serchStringView, setSerchStringView] = useState(serchColumn);

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getEntryForms({
      ...serchString,
      displayNumber,
      pageNumber,
    });
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.entryForms);
      const countEntryForms = Number(fetchData.countEntryForms);
      setTotalCount(countEntryForms);
      setMaxPageNumber(Math.ceil(countEntryForms / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber]);

  // 商材詳細
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string | { [key: string]: string | number }[];
  } | null>(null);

  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = key.id;
    const dataDetail = await getEntryForm(id);
    setDataDetail(dataDetail);
    if (!edit) {
      setIsLoading(false);
    }
  }
  // 商材編集
  const [editData, setEditData] = useState<EditDataDifine | null>(null);
  async function putEditData() {
    if (editData !== null) {
      setIsLoading(true);
      const id = editData.tableId as string;
      setEditData({
        ...editData,
        status: "editing",
      });
      const putResponce = await putEntryForm(editData);
      await getDataDetail({ id }, true);
      await getTableData(true);
      setEditData({
        ...editData,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 質問一覧詳細（メインテーブル）
  const [dataDetailProductOptionsMain, setDataDetailProductOptionsMain] =
    useState<{
      [key: string]: number | string | { [key: string]: string | number }[];
    } | null>(null);
  async function getDataDetailProductOptionsMain(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = getSubMainTableDetail.key.id;
    const { detail_data, option_data } = await getProductOption(id);
    setDataDetailProductOptionsMain({
      ...detail_data,
      option_data,
    });
    if (!edit) {
      setIsLoading(false);
    }
  }

  // エントリーフォーム新規作成
  const addEntryFormColumns = entryFormTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.add) {
        return {
          ...column,
          [difine.key]: "",
        };
      } else {
        return {
          ...column,
        };
      }
    },
    {},
  );
  const [onDataAddModalResult, setOnDataAddModalResult] = useState("");
  const [addEntryForm, setAddEntryForm] = useState<{
    [key: string]: string | boolean | any[];
  }>(addEntryFormColumns);
  const [onEntryFormAddModal, setEntryFormAddModal] = useState(false);
  async function postAddEntryForm() {
    setIsLoading(true);
    setEntryFormAddModal(false);
    const postResponce = await postEntryForm(addEntryForm);
    if (postResponce === "success") {
      await getTableData(false);
      setAddEntryForm(addEntryFormColumns);
      setOnDataAddModalResult("success");
    } else {
      setEntryFormAddModal(true);
      setOnDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 質問編集
  const [editProductOption, setEditProductOption] = useState<{
    [key: string]: any;
  } | null>(null);
  const [editProductOptionPlans, setEditProductOptionPlans] = useState<
    {
      service_plan_id: number;
      service_plan_name: string;
    }[]
  >([]);
  const [editProductOptionContents, setEditProductOptionContents] = useState<
    {
      service_content_id: number;
      service_content_name: string;
    }[]
  >([]);
  async function putEditProductOption() {
    if (editProductOption !== null) {
      const id = editProductOption.tableId as string;
      setIsLoading(true);
      setEditProductOption({
        ...editProductOption,
        status: "editing",
      });
      const putResult = await putProductOptions(editProductOption);
      if (putResult?.edit == "success") {
        if (getSubTableName.key.id && getSubTableName.name === "質問一覧") {
          await getSubtableDataProductOption();
        }
        if (
          getSubTableName.key.id &&
          getSubTableName.name === "チャットアプリ連携一覧"
        ) {
          await getSubtableDataEntryFormChatApp();
        }
        if (
          getSubSubTableName.key.id &&
          getSubSubTableName.name === "チャット連携-依存質問-選択肢一覧"
        ) {
          await getSubSubtableDataEntryFormChatAppDependSelect();
        }
        setIsLoading(true);
        await getDataDetailProductOptionsMain(true);
        await getTableData(true);
      }
      setEditProductOption({
        ...editProductOption,
        status: putResult?.warning || putResult?.edit,
      });
      setIsLoading(false);
    }
  }

  // エントリーフォーム一括編集
  const [editFormsStatus, setEditFormsStatus] = useState<{
    status:
      | "none"
      | "open"
      | "add"
      | "delete"
      | "success"
      | "loading"
      | "add_error"
      | "delete_error";
    message: string;
    editIDs: number[];
    action: null | 0 | 1;
    delete_option_names: string[];
    select_option: {
      option_name: string;
      outside_form_display: 0 | 1;
      sns_send: 0 | 1;
      required_optional: 0 | 1;
      option_type: 0 | 1 | 2 | 3 | 4;
      option_default_value: string;
      change_value_conf: 0 | 1;
      option_comment: string;
      tel_flg: 0 | 1;
      name_flg: 0 | 1;
      company_name_flg: 0 | 1;
      zip_code_flg: 0 | 1;
      address_flg: 0 | 1;
      space_flg: 0 | 1;
      mail_address_flg: 0 | 1;
      form_tel_flg: 0 | 1;
      multi_text_flg: 0 | 1;
      contract_number_flg: 0 | 1;
      half_width_number_flg: 0 | 1;
      option_select: string[];
    };
  }>({
    status: "none",
    message: "",
    editIDs: [],
    action: null,
    delete_option_names: [],
    select_option: {
      option_name: "",
      outside_form_display: 0,
      sns_send: 1,
      required_optional: 0,
      option_type: 0,
      option_default_value: "",
      change_value_conf: 0,
      option_comment: "",
      tel_flg: 0,
      name_flg: 0,
      company_name_flg: 0,
      zip_code_flg: 0,
      address_flg: 0,
      space_flg: 0,
      mail_address_flg: 0,
      form_tel_flg: 0,
      multi_text_flg: 0,
      contract_number_flg: 0,
      half_width_number_flg: 0,
      option_select: [""],
    },
  });
  useEffect(() => {
    if (editFormsStatus.status === "loading") {
      setIsLoading(true);
    } else if (editFormsStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [editFormsStatus]);
  const [editFormOptionNames, setEditFormOptionNames] = useState<string[]>([]);
  async function getEditFormDeleteOptionNames() {
    setEditFormsStatus({
      ...editFormsStatus,
      status: "loading",
    });
    const optionName = await getEntryFormDeleteOptionNames(
      editFormsStatus.editIDs,
    );
    if (optionName.length > 0) {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "delete",
      });
      let editFormOptionNames: string[] = [];
      optionName.map((option) => {
        editFormOptionNames.push(option.option_name);
      });
      setEditFormOptionNames(editFormOptionNames);
    } else {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "delete_error",
        message: "選択したフォームに共通の質問が存在しません。",
      });
    }
  }

  async function postEditFormOption() {
    setEditFormsStatus({
      ...editFormsStatus,
      status: "loading",
    });
    const responce = await postEntryFormOptions(
      editFormsStatus.editIDs,
      editFormsStatus.select_option,
    );
    if (responce == "success") {
      if (getSubTableName.name === "質問一覧") {
        await getSubtableDataProductOption();
      }
      setEditFormsStatus({
        ...editFormsStatus,
        status: "success",
      });
    } else {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "add_error",
        message: responce,
      });
    }
  }

  async function deleteEditFormOption() {
    setEditFormsStatus({
      ...editFormsStatus,
      status: "loading",
    });
    const responce = await deleteEntryFormOptions(
      editFormsStatus.editIDs,
      editFormsStatus.delete_option_names,
    );
    if (responce == "success") {
      if (getSubTableName.name === "質問一覧") {
        await getSubtableDataProductOption();
      }
      setEditFormsStatus({
        ...editFormsStatus,
        status: "success",
      });
    } else {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "delete_error",
        message: responce,
      });
    }
  }

  // 質問登録CSV取込
  const [postProductOptionCSVStatus, setPostProductOptionCSVStatus] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (postProductOptionCSVStatus.status === "loading") {
      setIsLoading(true);
    } else if (postProductOptionCSVStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postProductOptionCSVStatus]);
  async function postProductsCSV(postDatas: File) {
    setPostProductOptionCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostProductOptionCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "productOption";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostProductOptionCSVStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postProductOptionCSVStatus.result,
          header_location: decodedData.header_location,
        });
        // await getProductList();
        if (getSubTableName.key.id) {
          await getSubtableDataProductOption();
        }
        await getTableData(false);
        setPostProductOptionCSVStatus({
          status: "result",
          message: "CSV取込完了",
          result: postProductOptionCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostProductOptionCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postProductOptionCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostProductOptionCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }
  // サブテーブルデータの登録結果（共通）
  const [onSubtableDataAddModalResult, setOnSubtableDataAddModalResult] =
    useState("");

  // 質問一覧取得
  async function getSubtableDataProductOption() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getProductOptions(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // チャットアプリ連携一覧取得
  async function getSubtableDataEntryFormChatApp() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getEntryFormChatApps(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // チャットアプリ連携詳細取得
  async function getDataDetailEntryFormChatApp() {
    if (getSubTableDetail.key.id) {
      setIsLoading(true);
      const dataDetail = await getEntryFormChatApp(getSubTableDetail.key.id);
      setGetSubTableDetail({
        ...getSubTableDetail,
        dataDetail: dataDetail,
      });
      setIsLoading(false);
    }
  }

  // チャットアプリ連携編集
  const [editEntryFormChatApp, setEditEntryFormChatApp] =
    useState<EditDataDifine | null>(null);
  async function putEditEntryFormChatApp() {
    if (editEntryFormChatApp !== null) {
      const id = editEntryFormChatApp.tableId as string;
      setIsLoading(true);
      setEditEntryFormChatApp({
        ...editEntryFormChatApp,
        status: "editing",
      });
      const putResponce = await putEntryFormChatApp(editEntryFormChatApp);
      if (putResponce == "success") {
        await getSubtableDataEntryFormChatApp();
        await getDataDetailEntryFormChatApp();
        await getTableData(true);
      }
      setEditEntryFormChatApp({
        ...editEntryFormChatApp,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // チャットアプリ連携追加
  const [onEntryFormChatAppAddModal, setOnEntryFormChatAppAddModal] =
    useState(false);
  const [addEntryFormChatApp, setAddEntryFormChatApp] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    entry_form_id: "",
    sns_type: "",
    sns_id: "",
    sns_haeder: "",
    sns_footer: "",
  });
  async function postAddEntryFormChatApp() {
    setIsLoading(true);
    setOnEntryFormChatAppAddModal(false);
    const postResponce = await postEntryFormChatApp(addEntryFormChatApp);
    if (postResponce === "success") {
      await getTableData(true);
      await getSubtableDataEntryFormChatApp();
      setAddEntryFormChatApp({
        entry_form_id: "",
        sns_type: "",
        sns_id: "",
        sns_haeder: "",
        sns_footer: "",
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnEntryFormChatAppAddModal(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // チャットアプリ連携の削除
  const [deleteChatAppInf, setDeleteChatAppInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteChatApp() {
    setDeleteChatAppInf({
      ...deleteChatAppInf,
      status: "loading",
    });
    const id = deleteChatAppInf.key.id;
    const responce = await deleteEntryFormChatApp(id);
    if (responce == "success") {
      await getTableData(false);
      await getSubtableDataEntryFormChatApp();
      setDeleteChatAppInf({
        ...deleteChatAppInf,
        status: "success",
      });
    } else {
      setDeleteChatAppInf({
        ...deleteChatAppInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteChatAppInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteChatAppInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteChatAppInf]);

  // チャット連携-依存質問-選択肢 追加用
  const [onChatAppDependSelectAddModal, setOnChatAppDependSelectAddModal] =
    useState(false);
  const [
    onChatAppDependSelectAddModalResult,
    setOnChatAppDependSelectAddModalResult,
  ] = useState("");
  const [addChatAppDependSelect, setAddChatAppDependSelect] = useState<{
    entry_form_chat_app_id: string;
    option_id: string;
    option_select_id: string;
  }>({ entry_form_chat_app_id: "", option_id: "", option_select_id: "" });
  const [
    entryFormOptionsForChatAppDependFull,
    setEntryFormOptionsForChatAppDependFull,
  ] = useState<
    {
      option_id: number;
      option_name: string;
      option_selects: { id: number; option_select: string }[];
    }[]
  >([]);
  const chatAppDependSelectAddSubDataColumn = [
    {
      key: "option_id",
      name: "質問",
      table: false,
      tableValue: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "list" as const,
      addMessage: "",
    },
    {
      key: "option_select_id",
      name: "選択肢",
      table: false,
      tableValue: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "list" as const,
      addMessage: "",
    },
  ];
  function setGetSubSubTableAddChatAppDepend(value: {
    name: string;
    row: dataDifine | null;
  }) {
    if (value.name !== "依存質問-選択肢追加") return;
    const chatAppId =
      value.row?.id != null ? String(value.row.id) : getSubSubTableName.key?.id;
    if (!chatAppId) return;
    setAddChatAppDependSelect({
      entry_form_chat_app_id: chatAppId,
      option_id: "",
      option_select_id: "",
    });
    const entryFormId = getSubTableName.key.id;
    setIsLoading(true);
    if (entryFormId) {
      getEntryFormOptionsForChatAppDepend(entryFormId).then(
        (
          list: {
            option_id: number;
            option_name: string;
            option_selects: { id: number; option_select: string }[];
          }[],
        ) => {
          setEntryFormOptionsForChatAppDependFull(list);
          setOnChatAppDependSelectAddModal(true);
          setIsLoading(false);
        },
      );
    } else {
      setEntryFormOptionsForChatAppDependFull([]);
      setOnChatAppDependSelectAddModal(true);
      setIsLoading(false);
    }
  }
  async function postAddChatAppDependSelect() {
    if (
      !addChatAppDependSelect.entry_form_chat_app_id ||
      !addChatAppDependSelect.option_select_id
    )
      return;
    setOnChatAppDependSelectAddModal(false);
    setIsLoading(true);
    try {
      const res = await postEntryFormChatAppDependSelect({
        ...addChatAppDependSelect,
        option_select_id: Number(addChatAppDependSelect.option_select_id),
      });
      if (res === "success") {
        getSubSubtableDataEntryFormChatAppDependSelect();
        getSubtableDataEntryFormChatApp();
        setAddChatAppDependSelect({
          entry_form_chat_app_id: "",
          option_id: "",
          option_select_id: "",
        });
        setOnChatAppDependSelectAddModalResult("success");
      } else {
        setOnChatAppDependSelectAddModal(true);
        setOnChatAppDependSelectAddModalResult(
          res || "データの登録に失敗しました。",
        );
      }
    } finally {
      setIsLoading(false);
    }
  }

  // チャット連携-依存質問-選択肢 削除用
  const [deleteChatAppDependSelectInf, setDeleteChatAppDependSelectInf] =
    useState<{
      status: null | "loading" | "open" | "success" | "failed";
      key: { [key: string]: string };
      message: string;
    }>({ status: null, key: {}, message: "" });

  // エントリーフォーム - 質問一覧取得
  async function getSubSubtableDataProductOptionSelect() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getProductOptionSelects(
        getSubSubTableName.key.id,
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // エントリーフォーム - 依存プラン一覧取得
  async function getSubSubtableDataProductOptionDependPlan() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getProductOptionDependPlans(
        getSubSubTableName.key.id,
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // エントリーフォーム - 依存コンテンツ一覧取得
  async function getSubSubtableDataProductOptionDependContent() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getProductOptionDependContents(
        getSubSubTableName.key.id,
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // エントリーフォーム - 依存質問-選択肢一覧取得
  async function getSubSubtableDataProductOptionDependSelect() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getProductOptionDependSelects(
        getSubSubTableName.key.id,
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // エントリーフォーム - チャット連携-依存質問-選択肢一覧取得
  async function getSubSubtableDataEntryFormChatAppDependSelect() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getEntryFormChatAppDependSelects(
        getSubSubTableName.key.id,
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[],
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        },
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // 商材一覧
  const [productList, setProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  // 上位店一覧取得
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }[],
      );
      let productNameList = [""];
      fetchData.products.map(
        (company: {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }) => {
          if (!productNameList.includes(company.product_name)) {
            productNameList.push(company.product_name);
          }
        },
      );
      setProductNameList(productNameList);
    }
  }

  // サービス新規登録時、選択した上位店により商材一覧
  const [selectProductList, setSelectProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  useEffect(() => {
    let selectProductList: {
      id: number;
      high_rank_company_id: number;
      product_name: string;
    }[] = [];
    const high_rank_company_id = Number(addEntryForm.high_rank_company_id);
    productList.map((product) => {
      if (product.high_rank_company_id === high_rank_company_id) {
        selectProductList.push(product);
      }
    });
    setSelectProductList(selectProductList);
  }, [addEntryForm]);

  // データの削除
  const [deleteDataInf, setDeleteDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteData() {
    setDeleteDataInf({
      ...deleteDataInf,
      status: "loading",
    });
    const id = deleteDataInf.key.id;
    const responce = await deleteEntryForm(id);
    if (responce == "success") {
      await getTableData(false);
      setDeleteDataInf({
        ...deleteDataInf,
        status: "success",
      });
    } else {
      setDeleteDataInf({
        ...deleteDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteDataInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteDataInf]);

  // パートナー一覧
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [entryFormCompanyList, setEntryFormCompanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  // パートナー一覧取得
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[],
      );
      setEntryFormCompanyList([
        { id: 0, sale_company_name: "デフォルト" },
        ...(fetchData.saleCompanys as {
          id: number;
          sale_company_name: string;
        }[]),
      ]);
      let companyNameList = ["", "デフォルト"];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        },
      );
      setCampanyNameList(companyNameList);
    }
  }

  useEffect(() => {
    getHighRankCompanyList();
    getProductList();
    getSaleCompanysList();
  }, []);

  return (
    <Box
      style={{
        width: isSmartPhone
          ? "calc(100% - 31px)"
          : serchOpen || aiChatOpen
            ? "calc(100% - 331px)"
            : "calc(100% - 31px)",
        height: isSmartPhone ? "calc(100vh - 120px)" : "calc(100vh - 40px)",
      }}
    >
      <TableTopBar
        serch={true}
        serchOpen={serchOpen}
        setSerchOpen={handleSetSerchOpen}
        addDataNames={addDataNames}
        addDataName={addDataName}
        setAddDataName={setAddDataName}
        addCSVDataNames={addCSVDataNames}
        addCSVDataName={addCSVDataName}
        setAddCSVDataName={setAddCSVDataName}
        getXLSXDataNames={getXLSXDataNames}
        getXLSXDataName={getXLSXDataName}
        setGetXLSXDataName={setGetXLSXDataName}
        editDatasNames={editDatasNames}
        editDatasName={editDatasName}
        setEditDatasName={setEditDatasName}
        editIDs={editFormsStatus.editIDs}
        columnSettingOpen={false}
        openColumnSettingWindow={() => {}}
        aiChatOpen={aiChatOpen}
        setAiChatOpen={handleSetAiChatOpen}
      />
      <Box style={{ display: "flex" }}>
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            style={{
              width: isSmartPhone ? undefined : "100%",
              margin: isSmartPhone ? undefined : "10px 15px",
              height: isSmartPhone ? undefined : tableHeight,
              maxHeight: isSmartPhone ? undefined : tableHeight,
            }}
          >
            <ConstTable
              getTableData={getTableData}
              tableType={"main"}
              serchOpen={serchOpen}
              aiChatOpen={aiChatOpen}
              tableHeight={tableHeight}
              tableColumn={entryFormTableColumn}
              dataColumn={[]}
              rows={fetchData}
              displayNumber={displayNumber}
              setDisplayNumber={setDisplayNumber}
              displayNumbers={displayNumbers}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              maxPageNumber={maxPageNumber}
              totalCount={totalCount}
              getDataDetail={getDataDetail}
              getSubTableName={getSubTableName}
              setGetSubTableName={setGetSubTableName}
              getSubTableDetail={getSubTableDetail}
              setGetSubTableDetail={setGetSubTableDetail}
              setGetSubTableAdd={setGetSubTableAdd}
              setGetSubTableEditDirect={() => {}}
              getSubSubTableName={getSubSubTableName}
              setGetSubSubTableName={setGetSubSubTableName}
              getSubSubTableDetail={getSubSubTableDetail}
              setGetSubSubTableDetail={setGetSubSubTableDetail}
              setGetSubSubTableAdd={setGetSubSubTableAddChatAppDepend}
              setGetSubSubTableEditDirect={() => {}}
              tableTitle={entryFormTableColumn.title}
              switchTableCheckBox={() => {}}
              allCheckFlg={false}
              switchAllTableCheckBox={() => {}}
              editIDs={editFormsStatus.editIDs}
              setEditIDs={(editIDs: number[]) => {
                setEditFormsStatus({
                  ...editFormsStatus,
                  editIDs,
                });
              }}
              setEditDatasName={setEditDatasName}
              setGetSubMainTableName={setGetSubMainTableName}
              setTableOriginalFunc={setTableOriginalFunc}
              sortColumn={[]}
              setSortColumn={() => {}}
            />
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableHeight={tableHeight}
            tableColumn={entryFormTableColumn}
            dataColumn={[]}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={companyNameList}
            companyGroupNameList={[]}
            highRankCompanyNameList={highRankCompanyNameList}
            categoryNameList={[]}
            productNameList={productNameList}
            accountSaleNameList={[]}
            accountStaffNameList={[]}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
          />
        ) : null}
        {aiChatOpen && (
          <AiChatSideBar
            open={aiChatOpen}
            setOpen={handleSetAiChatOpen}
            pageName="EntryForm"
          />
        )}
      </Box>
      <DataDetailModal
        onModal={
          dataDetail !== null &&
          ((editData !== null && editData.status !== "editing") ||
            editData === null)
        }
        swCloseModal={() => setDataDetail(null)}
        detailTitle={entryFormTableColumn.detailTitle}
        editAuth={entryFormTableColumn.editAuth}
        dataColumn={entryFormTableColumn.dataColumn}
        subDataColumn={[]}
        dataDetail={dataDetail}
        setEditData={setEditData}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataEditModal
        onModal={editData !== null && editData.status !== "editing"}
        swCloseModal={() => setEditData(null)}
        editData={editData}
        setEditData={setEditData}
        putEditData={putEditData}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataDetailModal
        onModal={
          dataDetailProductOptionsMain !== null &&
          ((editProductOption !== null &&
            editProductOption.status !== "editing") ||
            editProductOption === null)
        }
        swCloseModal={() => {
          setDataDetailProductOptionsMain(null);
          setGetSubMainTableName({
            name: "",
            key: {},
          });
        }}
        detailTitle={"質問一覧詳細"}
        editAuth={entryFormTableColumn.editAuth}
        dataColumn={[]}
        subDataColumn={[]}
        dataDetail={dataDetailProductOptionsMain}
        setEditData={() => {}}
        option={true}
        setEditProduct={setEditProductOption}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={setEditProductOptionPlans}
        setEditProductOptionContents={setEditProductOptionContents}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <PostCSVModal
        onModal={
          postProductOptionCSVStatus.status !== "none" &&
          postProductOptionCSVStatus.status !== "loading"
        }
        swCloseModal={() => {
          setPostProductOptionCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postProductOptionCSVStatus}
        setPostCSVStatus={setPostProductOptionCSVStatus}
        postCSVFunc={postProductsCSV}
        postCSVTitle={"エントリーフォーム - 質問登録CSV取込"}
        postCSVColumn={postCSVColumnProductOption}
        postCSVColumnResult={postCSVColumnProductOptionResult}
        postCSVPath="productOption"
        productList={[]}
        categoryList={[]}
      />
      <DataAddModal
        onModal={onEntryFormAddModal}
        swCloseModal={() => {
          setEntryFormAddModal(false);
          setAddDataName("");
        }}
        addTitle={entryFormTableColumn.addTitle}
        dataColumn={entryFormTableColumn.dataColumn}
        subDataColumn={[]}
        postAddData={postAddEntryForm}
        addData={addEntryForm}
        setAddData={setAddEntryForm}
        companyList={entryFormCompanyList}
        highRankCompanyList={highRankCompanyList}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={selectProductList}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnDataAddModalResult("");
          setAddDataName("");
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onDataAddModalResult}
      />
      <ProductEditModal
        onModal={
          editProductOption !== null && editProductOption.status !== "editing"
        }
        swCloseModal={() => setEditProductOption(null)}
        editProduct={editProductOption}
        setEditProduct={setEditProductOption}
        putEditProduct={putEditProductOption}
        editProductOptionPlans={editProductOptionPlans}
        editProductOptionContents={editProductOptionContents}
        editTossUpFormOptionProducts={[]}
        editOutsideServices={[]}
      />
      <DataDeleteModal
        onModal={
          deleteDataInf.status !== null && deleteDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deleteDataInf={deleteDataInf}
        setDeleteDataInf={setDeleteDataInf}
        deleteData={deleteData}
        labels={{
          title: "エントリーフォーム削除",
          confirmBody: (
            <Alert severity="error">
              エントリーフォーム削除後、データは復元できません。
            </Alert>
          ),
          confirmButtonLabel: "エントリーフォーム削除",
          successMessage: "エントリーフォームの削除に成功しました。",
        }}
      />
      {/* チャットアプリ連携 詳細 */}
      <DataDetailModal
        onModal={
          getSubTableDetail.name ===
            entryFormTableColumn.subTable[0].subTableDetailTitle &&
          getSubTableDetail.dataDetail !== null &&
          ((editEntryFormChatApp !== null &&
            editEntryFormChatApp.status !== "editing") ||
            editEntryFormChatApp === null)
        }
        swCloseModal={() =>
          setGetSubTableDetail({
            name: "",
            key: {},
            dataDetail: null,
          })
        }
        detailTitle={entryFormTableColumn.subTable[0].subTableDetailTitle}
        editAuth={entryFormTableColumn.subTable[0].subTableEditAuth}
        dataColumn={[]}
        subDataColumn={entryFormTableColumn.subTable[0].subDataColumn}
        dataDetail={getSubTableDetail.dataDetail}
        setEditData={setEditEntryFormChatApp}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      {/* チャットアプリ連携 編集 */}
      <DataEditModal
        onModal={
          editEntryFormChatApp !== null &&
          editEntryFormChatApp.status !== "editing"
        }
        swCloseModal={() => setEditEntryFormChatApp(null)}
        editData={editEntryFormChatApp}
        setEditData={setEditEntryFormChatApp}
        putEditData={putEditEntryFormChatApp}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      {/* チャットアプリ連携 追加 */}
      <DataAddModal
        onModal={onEntryFormChatAppAddModal}
        swCloseModal={() => {
          setOnEntryFormChatAppAddModal(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
          setAddEntryFormChatApp({
            entry_form_id: "",
            sns_type: "",
            sns_id: "",
            sns_haeder: "",
            sns_footer: "",
          });
        }}
        addTitle={entryFormTableColumn.subTable[0].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={entryFormTableColumn.subTable[0].subDataColumn}
        postAddData={postAddEntryFormChatApp}
        addData={addEntryFormChatApp}
        setAddData={setAddEntryFormChatApp}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      {/* チャットアプリ連携 削除 */}
      <DataDeleteModal
        onModal={
          deleteChatAppInf.status !== null &&
          deleteChatAppInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteChatAppInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deleteDataInf={deleteChatAppInf}
        setDeleteDataInf={setDeleteChatAppInf}
        deleteData={deleteChatApp}
        labels={{
          title: "チャットアプリ連携削除",
          confirmBody: (
            <Alert severity="error">
              チャットアプリ連携削除後、データは復元できません。
            </Alert>
          ),
          confirmButtonLabel: "チャットアプリ連携削除",
          successMessage: "チャットアプリ連携の削除に成功しました。",
        }}
      />
      {/* チャット連携-依存質問-選択肢 追加 */}
      <DataAddModal
        onModal={onChatAppDependSelectAddModal}
        swCloseModal={() => {
          setOnChatAppDependSelectAddModal(false);
          setAddChatAppDependSelect({
            entry_form_chat_app_id: "",
            option_id: "",
            option_select_id: "",
          });
        }}
        addTitle={entryFormTableColumn.subTable[0].subTable[0].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={chatAppDependSelectAddSubDataColumn}
        postAddData={postAddChatAppDependSelect}
        addData={addChatAppDependSelect}
        setAddData={
          ((updater) => {
            setAddChatAppDependSelect((prev) => {
              const next = (
                typeof updater === "function" ? updater({ ...prev }) : updater
              ) as {
                entry_form_chat_app_id: string;
                option_id: string;
                option_select_id: string;
              };
              if (
                next.option_id !== undefined &&
                next.option_id !== prev.option_id
              ) {
                return { ...next, option_select_id: "" };
              }
              return next;
            });
          }) as Dispatch<
            SetStateAction<{ [key: string]: string | boolean | any[] }>
          >
        }
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
        subDataColumnOptionList={{
          option_id: entryFormOptionsForChatAppDependFull.map((o) => ({
            id: o.option_id,
            name: o.option_name,
          })),
        }}
        subDataColumnOptionListByKey={(key, addData) => {
          if (key !== "option_select_id") return undefined;
          const opt = entryFormOptionsForChatAppDependFull.find(
            (o) => String(o.option_id) === String(addData.option_id),
          );
          return opt
            ? opt.option_selects.map((s) => ({
                id: s.id,
                name: s.option_select,
              }))
            : [];
        }}
      />
      <DataAddModalResult
        onModal={onChatAppDependSelectAddModalResult !== ""}
        swCloseModal={() => {
          setOnChatAppDependSelectAddModalResult("");
        }}
        addModalTitle={
          entryFormTableColumn.subTable[0].subTable[0].subTableAddTitle
        }
        onDataAddModalResult={onChatAppDependSelectAddModalResult}
      />
      {/* チャット連携-依存質問-選択肢 削除 */}
      <DataDeleteModal
        onModal={
          deleteChatAppDependSelectInf.status !== null &&
          deleteChatAppDependSelectInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteChatAppDependSelectInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({ name: "", key: {} });
        }}
        deleteDataInf={deleteChatAppDependSelectInf}
        setDeleteDataInf={setDeleteChatAppDependSelectInf}
        deleteData={async () => {
          setDeleteChatAppDependSelectInf({
            ...deleteChatAppDependSelectInf,
            status: "loading",
          });
          setIsLoading(true);
          try {
            const id = deleteChatAppDependSelectInf.key.id;
            const res = await deleteEntryFormChatAppDependSelect(id);
            if (res === "success") {
              getSubSubtableDataEntryFormChatAppDependSelect();
              getSubtableDataEntryFormChatApp();
              setDeleteChatAppDependSelectInf({
                status: "success",
                key: {},
                message: "",
              });
            } else {
              setDeleteChatAppDependSelectInf({
                status: "failed",
                key: {},
                message: res || "",
              });
            }
          } finally {
            setIsLoading(false);
          }
        }}
        labels={{
          title: "依存質問-選択肢削除",
          confirmBody: (
            <Alert severity="error">削除後、データは復元できません。</Alert>
          ),
          confirmButtonLabel: "削除",
          successMessage: "削除に成功しました。",
        }}
      />
      <DataAddModalResult
        onModal={onSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubtableDataAddModalResult("");
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubtableDataAddModalResult}
      />
      <FormOptionsEditModal
        onModal={
          editFormsStatus.status !== "none" &&
          editFormsStatus.status !== "loading"
        }
        swCloseModal={() => {
          setEditFormsStatus({
            status: "none",
            message: "",
            editIDs: [],
            action: null,
            delete_option_names: [],
            select_option: {
              option_name: "",
              outside_form_display: 0,
              sns_send: 1,
              required_optional: 0,
              option_type: 0,
              option_default_value: "",
              change_value_conf: 0,
              option_comment: "",
              tel_flg: 0,
              name_flg: 0,
              company_name_flg: 0,
              zip_code_flg: 0,
              address_flg: 0,
              space_flg: 0,
              mail_address_flg: 0,
              form_tel_flg: 0,
              multi_text_flg: 0,
              contract_number_flg: 0,
              half_width_number_flg: 0,
              option_select: [""],
            },
          });
          setEditFormOptionNames([]);
          setEditDatasName("");
        }}
        backSwCloseModal={() => {
          setEditFormsStatus({
            ...editFormsStatus,
            status: "none",
            message: "",
            action: null,
          });
          setEditFormOptionNames([]);
          setEditDatasName("");
        }}
        editFormsStatus={editFormsStatus}
        setEditFormsStatus={setEditFormsStatus}
        getEditFormDeleteOptionNames={getEditFormDeleteOptionNames}
        editFormOptionNames={editFormOptionNames}
        postEditFormOption={postEditFormOption}
        deleteEditFormOption={deleteEditFormOption}
      />
    </Box>
  );
}

export default EntryForm;
